import { IUser } from '@novakid/ts-types';
import { createContext} from 'react';

export const UserContext = createContext<IUser | null>(null);